import { escapeAttr, escapeHtml } from "@emkit/builder-core";
import { looksLikeHtml, sanitizeRichHtml } from "./sanitize.js";
export const TEXT_DEFAULTS = {
    text: "The quick brown fox jumps over the lazy dog.",
    align: "left",
    size: "base",
};
const SIZE_PX = {
    sm: "14px",
    base: "16px",
    lg: "18px",
    xl: "20px",
};
export const textWidget = {
    type: "text",
    defaultProps: TEXT_DEFAULTS,
    renderHtml(props) {
        const styleParts = [];
        if (props.align)
            styleParts.push(`text-align:${props.align}`);
        if (props.color)
            styleParts.push(`color:${escapeAttr(props.color)}`);
        if (props.size)
            styleParts.push(`font-size:${SIZE_PX[props.size]}`);
        styleParts.push("line-height:1.6");
        const style = ` style="${styleParts.join(";")}"`;
        const body = looksLikeHtml(props.text)
            ? sanitizeRichHtml(props.text)
            : `<p>${escapeHtml(props.text).replace(/\n/g, "<br>")}</p>`;
        return `<div class="emk-text"${style}>${body}</div>`;
    },
};
//# sourceMappingURL=text.js.map